import fetch from 'isomorphic-fetch';
import qs from 'query-string';
import cachedFetch from './cachedFetch';

export function checkStatus(response) {
  if (response.ok) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

export function parseJSON(response) {
  const contentType = response.headers.get('Content-Type');
  if (contentType.indexOf('json') > -1) {
    return response.json();
  }
  return response.text();
}

const consoleError = error => {
  try {
    // eslint-disable-next-line no-console
    console.error(error);
    // eslint-disable-next-line no-empty
  } catch (ie11) {
    // throw error;
  }
};

export const dispatchError = (dispatch, actionCreator) => error => {
  if (!error) {
    return dispatch(actionCreator('An error occurred.'));
  }

  // this error likely came from an action or a reducer (not the server)
  if (error instanceof Error && !error.response) {
    consoleError(error);
    return dispatch(actionCreator(error.stack || error.toString()));
  }

  const titleMessage =
    error.message === 'Bad Request' ? 'Oops!' : 'An error occurred.';

  if (!error.response) {
    return dispatch(actionCreator(titleMessage));
  }

  let getter = null;
  const contentType = error.response.headers.get('Content-Type');
  if (contentType && contentType.indexOf('json') > -1) {
    getter = error.response.json.bind(error.response);
  } else {
    getter = error.response.text.bind(error.response);
  }

  return getter().then(errorData => {
    if (
      errorData &&
      errorData.length > 0 &&
      typeof errorData.map === 'function'
    ) {
      const errors = {};
      const messages = errorData
        .map(e => {
          const propertyName = e['<PropertyName>k__BackingField'];
          const attemptedValue = e['<AttemptedValue>k__BackingField'];
          const errorMessage = e['<ErrorMessage>k__BackingField'];
          errors[propertyName] = errorMessage;
          return (attemptedValue ? `'${attemptedValue}': ` : '') + errorMessage;
        })
        .join('<br />');

      return dispatch(
        actionCreator(
          `<strong>${titleMessage}</strong><br />${messages}`,
          errors
        )
      );
      // eslint-disable-next-line no-else-return
    } else if (errorData && typeof errorData === 'string') {
      return dispatch(
        actionCreator(`<strong>${titleMessage}</strong><br />${errorData}`)
      );
    }

    if (errorData && errorData.Message) {
      return dispatch(
        actionCreator(
          `<strong>${titleMessage}</strong><br />` +
            `<strong>Message</strong>: ${errorData.Message}<br />` +
            `${
              errorData.ExceptionMessage == null
                ? ''
                : `<strong>Reason</strong>: ${errorData.ExceptionMessage}`
            }` +
            `${
              errorData.InnerException == null
                ? ''
                : errorData.InnerException.InnerException == null
                ? `<br /><strong>Details</strong>: ${errorData.InnerException.ExceptionMessage}`
                : `<br /><strong>Details</strong>: ${errorData.InnerException.InnerException.ExceptionMessage}`
            }`
        )
      );
    }

    return dispatch(actionCreator(titleMessage));
  });
};

export const dispatchData = (dispatch, actionCreator) => data => {
  let retData = data;

  if ('d' in data) {
    retData = data.d;
  }

  dispatch(actionCreator(retData));

  return retData;
};

export function fetchGet(config, path, args = {}) {
  return fetch(
    `${config.apiUrl}/${path}?${qs.stringify({
      ...args,
      client: config.client
    })}`
  )
    .then(checkStatus)
    .then(parseJSON);
}

export function fetchPost(config, path, args = {}, body = {}) {
  return fetch(
    `${config.apiUrl}/${path}?${qs.stringify({
      ...args,
      client: config.client
    })}`,
    {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }
  )
    .then(checkStatus)
    .then(parseJSON);
}

export function cachedFetchGet(config, path, args = {}) {
  return cachedFetch(
    `${config.apiUrl}/${path}?${qs.stringify({
      ...args,
      client: config.client
    })}`
  )
    .then(checkStatus)
    .then(parseJSON);
}
